import { Link } from "react-router-dom";
import SectionHeader from "@/components/feature/SectionHeader";
import { categories } from "@/mocks/categories";
import { comicsByCategory } from "@/mocks/comics";

export default function Categories() {
  return (
    <section className="py-14 md:py-20">
      <div className="container-site">
        <SectionHeader
          eyebrow="世界观分类"
          title="三大奇幻题材，一次看个够"
          subtitle="无论你偏爱穿越冒险、精灵羁绊还是东方神话，都能在这里快速锁定心仪的妖精漫画世界。"
        />
        <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
          {categories.map((c) => (
            <Link
              key={c.slug}
              to={`/category/${c.slug}`}
              className="group relative h-72 overflow-hidden rounded-lg md:h-80"
            >
              <img
                src={c.banner}
                alt={`${c.name} 妖精漫画分类`}
                loading="lazy"
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/30 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-5">
                <span className="text-xs uppercase tracking-wider text-accent-300">{c.en}</span>
                <h3 className="mt-1 font-heading text-xl font-bold text-background-50">{c.name}</h3>
                <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-background-100/90">{c.intro}</p>
                <span className="mt-3 inline-flex items-center gap-1 text-xs font-medium text-accent-200">
                  {comicsByCategory(c.slug).length} 部精选作品
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}